import React from "react";

function LoginFormV2({ handleSubmit, credentials, handleChange, loading,setShowForgotPassword,theme }) {
  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col justify-around m-4"
    >
      <div className="space-y-6 pb-5">
        {/* Email Field */}
        <div>
          <label
            htmlFor="username"
            className="block text-2xl font-medium text-white mb-2"
          >
            Nombre de Usuario
          </label>
          <input
            type="text"
            id="username"
            name="username"
            value={credentials.username}
            onChange={handleChange}
            className="w-full text-2xl px-4 py-3 border-[1px] border-[#FE510066] rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            required
          />
        </div>

        {/* Password Field */}
        <div>
          <label
            htmlFor="password"
            className="block text-2xl font-medium text-white mb-2"
          >
            Contraseña
          </label>
          <input
            type="password"
            id="password"
            name="password"
            value={credentials.password}
            onChange={handleChange}
            className="w-full px-4 py-3 text-2xl tablet:text-lg border-[1px] border-[#FE510066] rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            required
          />
        </div>

        {/* Forgot Password */}
        <div className="flex justify-center">
          <button
            type="button"
            onClick={() => setShowForgotPassword(true)}
            className="text-[15px] text-white hover:text-white/70 transition-colors font-semibold"
          >
            Olvidaste tu contraseña?
          </button>
        </div>
      </div>

      {/* Grupo Inferior: Botones */}
      <div className="space-y-4 flex flex-col items-center justify-center">
        {/* Sign In Button */}
        <button
          type="submit"
          disabled={loading}
          style={{
            backgroundColor: "#fff",
            color: "#FE5100",
          }}
          className="tablet:w-[60%] flex items-center justify-center gap-2 text-[18px] font-semibold py-3 px-4 rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Iniciando sesión..." : <>Iniciar sesión <span style={{ fontSize: "1.2em" }}>→</span></>}
        </button>

        {/* Google Sign In Button */}
        <button
          type="button"
          style={{ marginTop: "2.5rem" }}
          className="tablet:w-[60%]  flex items-center justify-center gap-3 bg-white text-[#3c4043] text-[15px] font-medium py-3 px-4 rounded-full shadow-sm hover:shadow-md transition-shadow border border-[#dadce0]"
        >
          <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
            <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.836.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
            <path d="M3.964 10.707A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.039l3.007-2.332z" fill="#FBBC05"/>
            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.961L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
          </svg>
          Acceder con Google
        </button>
        {/* Register Link */}
        {/* <div className="flex items-center justify-center gap-2 ">
          <p className="text-zinc-300 text-[12px] tablet:text-[14px]">¿No tienes una cuenta?</p>
          <a href="https://extranet.inatrans.cl/pre-inscription"
            type="button"
            className="text-[#44BCF9] hover:text-[#41Bad8] text-[15px] tablet:text-[18px] font-medium cursor-pointer transition-colors duration-200 hover:underline focus:outline-none focus:underline"
          >
            Regístrate aquí
          </a>
        </div> */}
      </div>
    </form>
  );
}

export default LoginFormV2;
